import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, formatApiError } from "@/lib/auth";
import { toast } from "sonner";

export default function Login() {
  const { login, startGoogle } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState(""); const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false); const [err, setErr] = useState(null);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setErr(null);
    try { await login(email, password); nav("/"); }
    catch (e) { setErr(formatApiError(e.response?.data?.detail) || e.message); }
    finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0c0a09] px-4" data-testid="login-page">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <div className="text-[10px] font-mono uppercase tracking-[0.3em] text-orange-500/80">Executive Assistant</div>
          <h1 className="font-serif text-5xl mt-2 tracking-tight text-stone-50">Copilot</h1>
        </div>
        <form onSubmit={submit} className="border border-stone-800 bg-[#1c1917] p-8 space-y-4">
          <h2 className="text-xl font-serif text-stone-100">Sign in</h2>
          <input data-testid="login-email" type="email" placeholder="Email" required
            value={email} onChange={(e) => setEmail(e.target.value)}
            className="w-full bg-stone-900 border border-stone-800 px-3 py-2.5 text-sm text-stone-100 focus:border-orange-600 outline-none"/>
          <input data-testid="login-password" type="password" placeholder="Password" required
            value={password} onChange={(e) => setPassword(e.target.value)}
            className="w-full bg-stone-900 border border-stone-800 px-3 py-2.5 text-sm text-stone-100 focus:border-orange-600 outline-none"/>
          {err && <div className="text-xs text-red-400 font-mono" data-testid="login-error">{err}</div>}
          <button data-testid="login-submit" type="submit" disabled={busy}
            className="w-full bg-orange-600 hover:bg-orange-500 disabled:bg-stone-800 text-white text-xs uppercase tracking-widest font-mono py-2.5 transition-colors">
            {busy ? "…" : "Sign in"}
          </button>
          <div className="text-[10px] uppercase tracking-widest font-mono text-stone-500 text-center">or</div>
          <button data-testid="login-google" type="button" onClick={startGoogle}
            className="w-full border border-stone-700 hover:border-stone-500 text-stone-100 text-xs uppercase tracking-widest font-mono py-2.5 transition-colors">
            Continue with Google
          </button>
          <div className="text-xs text-stone-500 text-center pt-2">
            New here? <Link data-testid="link-register" to="/register" className="text-orange-500 hover:underline">Create account</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
